import styled from "styled-components"

export const LinkCardContainer = styled.div`
  /* hack way to span wider than the blog post container */
  @media only screen and (min-width: 1251px) {
    width: 134%;
    margin-left: -17%;
    margin-right: -17%;
  }
  @media only screen and (min-width: 801px) and (max-width: 1250px) {
    width: 120%;
    margin-left: -10%;
    margin-right: -10%;
  }
`

export const BlogCourseLinkContainer = styled.div`
  display: flex;
  border-radius: 3px;
  margin-top: 30px;
  box-shadow: 1px 2px 20px rgba(19, 15, 235, 0.1);
  cursor: pointer;
  min-height: 198px;

  img {
    width: 198px;
    object-fit: cover;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  @media screen and (max-width: 800px) {
    flex-direction: column;
    margin: 20px 0;

    img {
      width: 100%;
      height: auto;
      border-top-right-radius: 3px;
      border-bottom-left-radius: 0px;
    }
  }
`

BlogCourseLinkContainer.displayName = "BlogCourseLinkContainer"

export const BlogCourseLinkDetails = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  p {
    margin: 0;
    ${({ theme: { typography } }) => typography.desktop.excerpt};
  }

  @media screen and (max-width: 800px) {
    padding: 25px;
    p {
      ${({ theme: { typography } }) => typography.mobile.excerpt};
    }
  }
`

BlogCourseLinkDetails.displayName = "BlogCourseLinkDetails"

export const BlogLinkTitle = styled.h5`
  ${({ theme: { typography } }) => typography.desktop.h5};
  margin-bottom: 25px;
  @media screen and (max-width: 800px) {
    ${({ theme: { typography } }) => typography.mobile.h5};
    margin-bottom: 20px;
  }
`

BlogLinkTitle.displayName = "BlogLinkTitle"

export const BlogCourseLinkTag = styled.a.attrs({
  target: "_blank",
  rel: "noopener noreferrer",
  "aria-label": "course image link",
})`
  text-decoration: none;
`

BlogCourseLinkTag.displayName = "BlogCourseLinkTag"
